export enum EnableAccessGrupsStatus {
  NotRequested = 'NOT_REQUESTED',
  Requested = 'REQUESTED',
}
